import { z } from 'zod';
import { dateField } from '../schemas/common.schemas';

// Schemas (source of truth)
export const tagCertificateSchema = z.object({
	name: z.string(),
	expirationDate: dateField,
	creationDate: dateField,
});

// Types (derived from schemas)
export type ITagCertificate = z.infer<typeof tagCertificateSchema>;
